import { ProblemOrdersAnalyticsTotalsSchema } from "@redotech/redo-model/analytics/analytics";
import { StandardCarrier } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import z from "zod/v4";

export const getProblemOrdersAnalytics = {
  name: "getProblemOrdersAnalytics",
  input: z.object({
    numUnits: z.number().positive(),
    startDate: z.date(),
    problemType: z.string(),
    carrier: z.union([z.literal("all"), z.enum(StandardCarrier)]),
  }),
  output: ProblemOrdersAnalyticsTotalsSchema,
};
